import React from 'react';

export const IconPlus = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M6,0 C6.55228475,0 7,0.44771525 7,1 L7,5 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L7,7 L7,11 C7,11.5522847 6.55228475,12 6,12 C5.44771525,12 5,11.5522847 5,11 L5,6.999 L1,7 C0.44771525,7 0,6.55228475 0,6 C0,5.44771525 0.44771525,5 1,5 L5,4.999 L5,1 C5,0.44771525 5.44771525,0 6,0 Z"
			/>
		</svg>
	);
};
